import {camelifyString, constifyString } from 'service/UtilService';
import ApiService from 'service/ApiService';

export default class RequestActionMetaBuilder {
  constructor(prefix) {
    this.prefix = prefix;
    this.identifiers = {};
    this.actionCreators = {};
    this.urlBuilders = {};
    this.getApiUrl = ApiService.getApiUrl.bind(ApiService);
  }

  addRequestIdentifiers = (name) => {
    const constified = constifyString(name);

    this.identifiers[constified+"_REQUEST"]=this.prefix+"_"+constified+"_REQUEST";
    this.identifiers[constified+"_RESPONSE"]=this.prefix+"_"+constified+"_RESPONSE";
  }

  addRequestActionCreators = (name) => {
    const camelified = camelifyString(name);
    const constified = constifyString(name);

    this.actionCreators[camelified+"Request"] = (params) => {
      return { type: this.identifiers[constified+"_REQUEST"], payload: {params: params} };
    }

    this.actionCreators[camelified+"Response"] = ({ payload, error, requestAction }) => {
      return { type: this.identifiers[constified+"_RESPONSE"], payload: payload, error: error, requestAction };
    }
  }

  addRequestUrlBuilder = (name, builder) => {
    this.urlBuilders[camelifyString("build_"+name+"_url")] = (params) => this.getApiUrl(builder(params));
  }

  defineRequest = ({ name, urlBuilder}) => {
    this.addRequestIdentifiers(name);
    this.addRequestActionCreators(name);
    this.addRequestUrlBuilder(name, urlBuilder);
  }

  defineOther = ({ name }) => {
      const camelified = camelifyString(name);
      const constified = constifyString(name);
      this.identifiers[constified]=this.prefix+"_"+constified;
      this.actionCreators[camelified] = (payload) => {
          return { type: this.identifiers[constified], payload: { ...payload } };
      }
  }
}



// WEBPACK FOOTER //
// ./src/storeState/ActionMetaBuilder.js